import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=38951823&scoped=true&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"
import style0 from "./Document.vue?vue&type=style&index=0&id=38951823&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38951823",
  null
  
)

export default component.exports